import { gql } from '@apollo/client';
import { ServiceGroupFragment } from '@/inpatient-patient-pwa/organisms/OrderButton/graphql';

export const SELECT_QUERY = gql`
  query FetchServices(
    $floorId: UUID!
    $admissionId: UUID!
    $category: EnumPatientCallReasonsCategory
  ) {
    groups: patientCallGroupItems(
      orderBy: ORDER_ASC
      filter: {
        parentId: { isNull: true }
        service: {
          enabled: { equalTo: true }
          category: { equalTo: $category }
        }
        enabled: { equalTo: true }
        group: {
          active: { equalTo: true }
          locationIds: { contains: [$floorId] }
        }
      }
    ) {
      nodes {
        ...ServiceGroupFragment

        children: childPatientCallGroupItems(
          orderBy: ORDER_ASC
          filter: {
            service: { category: { equalTo: $category } }
            enabled: { equalTo: true }
          }
        ) {
          totalCount
          nodes {
            ...ServiceGroupFragment
            children: childPatientCallGroupItems(
              orderBy: ORDER_ASC
              filter: {
                service: { category: { equalTo: $category } }
                enabled: { equalTo: true }
              }
            ) {
              totalCount
              nodes {
                ...ServiceGroupFragment
              }
            }
          }
        }
      }
    }
  }
  ${ServiceGroupFragment}
`;

/**
 * Lists the top-level items of a specific `service_group` — used when the
 * HomePage navigates to the listing for an APP_FRONT_PAGE `serviceGroup` button.
 */
export const SELECT_GROUP_QUERY = gql`
  query FetchGroupServices(
    $admissionId: UUID!
    $groupId: UUID!
    $floorId: UUID!
  ) {
    groups: patientCallGroupItems(
      orderBy: ORDER_ASC
      filter: {
        parentId: { isNull: true }
        enabled: { equalTo: true }
        group: {
          id: { equalTo: $groupId }
          active: { equalTo: true }
          locationIds: { contains: [$floorId] }
        }
      }
    ) {
      nodes {
        ...ServiceGroupFragment

        children: childPatientCallGroupItems(
          orderBy: ORDER_ASC
          filter: { enabled: { equalTo: true } }
        ) {
          totalCount
          nodes {
            ...ServiceGroupFragment
            children: childPatientCallGroupItems(
              orderBy: ORDER_ASC
              filter: { enabled: { equalTo: true } }
            ) {
              totalCount
              nodes {
                ...ServiceGroupFragment
              }
            }
          }
        }
      }
    }
  }
  ${ServiceGroupFragment}
`;

export const FETCH_ADMISSION_COVERAGE = gql`
  query CheckAdmissionCoverageQuery(
    $admissionId: UUID!
    $type: EnumCheckCoverageType!
  ) {
    checkAdmissionCoverage(admissionId: $admissionId, type: $type) {
      admissionId
      status
    }
  }
`;

export const ALERT_SUBSCRIPTION = gql`
  subscription onAlertChanged($admissionId: UUID!) {
    alertChanges: alertChangesByAdmissionId(admissionId: $admissionId) {
      event
      alertData {
        id
        createdAt
        resolvedAt
        cancelledAt
        reasonId
        groupId
      }
    }
  }
`;
